<template>
  <div>
    <el-form :model="formData" label-width="200px" :rules="rules">
      <el-form-item label="物件番号：" >
       {{formData.wujian_id}}
        <el-form-item label="窗番编码：" >
          {{formData.unit_no}}
        </el-form-item>
        <el-form-item label="批号：">
          {{formData.lot_no}}
        </el-form-item>
      </el-form-item>
      <el-form-item label="工站："  prop="star" v-for="item in formData.scanRecordList" :key="item.id">
        <el-select v-model="item.stage_id" placeholder="工站选择" class="toolbar_item" style="width: 200px">
          <el-option v-for="dict in stageData" :key="dict.id" :label="dict.stage_name" :value="dict.id"></el-option>
        </el-select>
      <el-form-item label="工站时间："  prop="star">
        <el-date-picker
            v-model="item.scan_time"
            type="datetime"
            placeholder="请选择时间"
            style="width: 200px"
            format="YYYY-MM-DD HH:mm"
            value-format="YYYY-MM-DD HH:mm"
        />
      </el-form-item>
      </el-form-item>
      <el-form-item label="处理状态："  prop="star">
        <el-select v-model="formData.state" style="width: 200px" clearable>
          <el-option v-for="dict in stateList" :key="dict.id" :label="dict.name" :value="dict.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="异常原因：" prop="star">
        <el-input v-model="formData.reason" style="width: 350px" type="textarea"  clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="updateWindowError" :loading="loading">提交</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>

export default {
  name: "AmWindowErrorEdit",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading:false,
      stageData:[],
      cnt:0,
      formData:{
        window_id:'',
        wujian_id:'',
        unit_no:'',
        lot_no:'',
        line_id:'',
        state:'',
        reason:'',
        scanRecordList:[]
      },
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {
    stateList() {
      return this.$store.getters['core/getDictList']('window_error_states');
    }
  },
  methods:{
    getList() {
      this.formData = this.parentData
      this.$axios.post('am/windowError/getWindowError', this.parentData.id).then(response => {
        let res = response.data
        this.formData.scanRecordList = res.data

      })
    },
    async getStageList() {
      let {data: res} = await this.$axios.get('/am/windowError/getStageAll');
      this.stageData = res.data;
    },
    updateWindowError(){
      this.loading = true
      this.$axios.post('am/windowError/updateWindowError', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        return this.$message.success('编辑成功!');
        this.loading = false
      })
    },
  },created() {
    this.getList()
    this.getStageList()
  }
}
</script>

<style scoped>
</style>